import { css as t } from "../stitches.config.es.js";
const o = t({
  fontSize: "$medium",
  margin: 0
});
export {
  o as statusLabel
};
//# sourceMappingURL=SeedStatus.styles.es.js.map
